import type {
  SecretReferenceInner,
  SecretReferenceValue,
  VaultEntry,
} from '@/types/configuration'

export function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export function isSecretReference(value: unknown): value is SecretReferenceValue {
  if (!isPlainObject(value) || !('$secret' in value)) {
    return false
  }

  return isPlainObject((value as Record<string, unknown>).$secret)
}

export function buildSecretReference(input: {
  ref: string
  vault?: string
  version?: string
}): SecretReferenceValue {
  const secret: SecretReferenceInner = {
    ref: input.ref.trim(),
  }

  if (input.vault && input.vault.trim()) {
    secret.vault = input.vault.trim()
  }

  if (input.version && input.version.trim()) {
    secret.version = input.version.trim()
  }

  return { $secret: secret }
}

export function getSecretReference(value: unknown): SecretReferenceInner | null {
  if (!isSecretReference(value)) {
    return null
  }

  return value.$secret
}

export function isVaultEntry(value: unknown): value is VaultEntry {
  return isPlainObject(value)
    && typeof value.provider === 'string'
    && typeof value.uri === 'string'
}